<template>
  <div class="search-results-article">
    <div class="results">
      <SearchArticleList
        :article-list="results"
        :fallback="$production.toUpperCase() !== 'READ'"
        periodical-articles
      >
        <template #info="{ article: articleItem }">
          <span class="periodical-title"
                v-html="articleItem.periodical_title +
                  '&nbsp; ' + articleItem.periodical_volume_publication_date.slice(0, 7) +
                  '&nbsp; Vol. ' + articleItem.periodical_volume +
                  ' /&nbsp;'"
          />
          <span v-for="(author, index) in articleItem.author" :key="index" class="author"
                v-html="index === articleItem.author.length - 1 ? author.name : author.name + '、'"
          />
        </template>
      </SearchArticleList>
    </div>
    <SearchNoResultsText :results="results" />
  </div>
</template>

<script>
import SearchNoResultsText from '@/components/search/SearchNoResultsText'
import SearchArticleList from '@/components/search/SearchArticleList'

export default {
  name: 'SearchResultsPeriodicalArticle',
  components: {
    SearchNoResultsText,
    SearchArticleList
  },
  directives: {},
  props: {},
  data() {
    return {}
  },
  computed: {
    results() {
      const matchedObj = this.$store.getters.getSearchResults.find(searchObj => searchObj['periodical_article'])
      return (matchedObj && matchedObj['periodical_article']) ? matchedObj['periodical_article'] : []
    }
  },
  watch: {},
  created() {},
  mounted() {},
  updated() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
.article-list {
  /deep/ .article-item {
    width: calc((100% - 48px) / 2);
    margin: 0 0 36px 0;
    vertical-align: top;
    text-align: left;
    text-decoration: none;
    cursor: pointer;
    // border: 1px solid $link-hover;
    .subject {
      // height: 54px;
      font-size: 24px;
      font-weight: 500;
      line-height: 1.63;
      color: $grey-50;
      width: 100%;
      margin-bottom: 8px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .info{
      font-size: 16px;
      font-weight: bold;
      line-height: 1.63;
      color: $grey-9b;
      max-height: 28px;
      @include ellipsis-with-lines(1);
    }
    .content {
      height: 78px;
      font-size: 16px;
      font-weight: 500;
      line-height: 1.63;
      color: $grey-9b;
      @include ellipsis-with-lines(3);
    }
  }
  /deep/ .article-item-container:nth-child(2n - 1) .article-item {
    margin-right: 48px;
  }
}
@media only screen and (min-width: 1440px) {}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {
  .article-list {
    /deep/ .article-item {
      width: calc((100% - 30px) / 2);
    }
    /deep/ .article-item-container:nth-child(2n - 1) .article-item {
      margin-right: 30px;
    }
  }
}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {
  .article-list {
    /deep/ .article-item {
      width: 100%;
      margin-bottom: 24px;
      .subject {
        height: calc(20px * 1.6);
        font-size: 20px;
        line-height: 1.6
      }
      .content {
        height: calc(14px * 1.64 * 3);
        font-size: 14px;
        line-height: 1.64
      }
    }
    /deep/ .article-item-container:nth-child(2n - 1) .article-item {
      margin-right: 0;
    }
  }
}
@media only screen and (max-width: 767.98px) {
  .article-list {
    /deep/ .article-item {
      width: 100%;
      margin-bottom: 24px;
      .subject {
        height: calc(20px * 1.6);
        font-size: 20px;
        line-height: 1.6
      }
      .content {
        height: calc(14px * 1.64 * 3);
        font-size: 14px;
        line-height: 1.64
      }
    }
    /deep/ .article-item-container:nth-child(2n - 1) .article-item {
      margin-right: 0;
    }
  }
}
</style>
